import React from 'react';
import PropTypes from 'prop-types';
import ATselect from '@at.govt.nz/select';
import { formatRouteDesc } from '../../../components/Common';
import AliasMacronService from '../../../services/AliasMacronService';

const bem = 'tt-route-dropdown';
export default class RouteDropdown extends React.PureComponent {
  render() {
    const props = this.props;
    const { selectedHeadsign, selectedRoute, onRouteDropdownChange } = props;
    const { routes } = selectedHeadsign;
    const showDropdown = routes && routes.length > 1;
    const routeTitle = AliasMacronService.getMacronisedText((routes && routes.length === 1) ? formatRouteDesc(selectedHeadsign, routes[0]) : 'Unknown Route');
    const value = selectedRoute ? selectedRoute.shape_ids : '';

    const options = !selectedHeadsign.routes ? [] : selectedHeadsign.routes.map(route => ({
      value: route.shape_ids,
      text: AliasMacronService.getMacronisedText(formatRouteDesc(selectedHeadsign, route)),
    }));

    return (
      showDropdown
        ? (
          <div className={bem}>
            <div className={`${bem}__wrapper`}>
              <div className={`${bem}__label`}>Route options</div>
              <ATselect
                data-testid={`${bem}__select`}
                className={`${bem}__select`}
                dark={false}
                options={options}
                block
                onChange={ev => onRouteDropdownChange(ev.target.value)}
                value={value}
                aria-label="Route options"
              />
            </div>
          </div>
        )
        : <h2>{routeTitle}</h2>
    );
  }
}

RouteDropdown.defaultProps = {
  selectedRoute: null,
};
RouteDropdown.propTypes = {
  selectedHeadsign: PropTypes.object.isRequired,
  selectedRoute: PropTypes.object,
  onRouteDropdownChange: PropTypes.func.isRequired,
};
